import React from 'react';

import { DefaultFilledButton } from '@magoosh/lib/button';
import { SimpleBarChart } from '@magoosh/lib/charts';
import { ExamSectionIcon } from '@magoosh/lib/icons';
import { paths } from 'config/path_helpers';

import ContextualLink from '@test_prep/app/components/contextual_link';

import { FlashcardDeckSet } from '../../types';

import colors from '@magoosh/lib/styles/colors.module.scss';

export default (props: FlashcardDeckSet) => {
  const subjectFromName = () => {
    if (props.name.indexOf('Math') !== -1) return 'math';
    if (props.name.indexOf('Vocabulary') !== -1) return 'verbal';
    return null;
  };

  return (
    <div className="d-flex flex-column gap-m">
      <div className="align-items-center d-flex gap-s">
        <ExamSectionIcon
          colorPalette={{ dark: colors.blue, light: colors.blueLight }}
          name={props.name}
          subject={subjectFromName()}
        />
        <h3 className="u-margin-A-n">{props.name}</h3>
      </div>

      <div className="d-flex flex-column gap-s">
        <div className="align-items-lg-center d-flex flex-1 flex-column flex-md-row gap-xs gap-md-l">
          <div style={{ minWidth: 150 }}>
            {props.name.indexOf('Vocabulary') !== -1 ? 'Words' : 'Cards'} Attempted
          </div>

          <div className="flex-1">
            <SimpleBarChart
              colorPalette={{ dark: colors.dataDarkBlue, light: colors.dataMutedBlue }}
              data={[
                {
                  label: 'Attempted',
                  percentage: true,
                  value: Math.ceil((props.cards.attempted / props.cards.total) * 100)
                }
              ]}
              hideLabel
            />
          </div>
        </div>

        <div className="align-items-lg-center d-flex flex-1 flex-column flex-md-row gap-xs gap-md-l">
          <div style={{ minWidth: 150 }}>
            {props.name.indexOf('Vocabulary') !== -1 ? 'Words' : 'Cards'} Mastered
          </div>

          <div className="flex-1">
            <SimpleBarChart
              colorPalette={{ dark: colors.dataDarkBlue, light: colors.dataMutedBlue }}
              data={[
                {
                  label: 'Attempted',
                  percentage: true,
                  value: Math.ceil((props.cards.mastered / props.cards.total) * 100)
                }
              ]}
              hideLabel
            />
          </div>
        </div>
      </div>

      <hr className="u-margin-A-n" />

      <div className="d-flex gap-s">
        <ContextualLink href={paths.flashcardsDeck(props.currentDeck.slug, props.slug)}>
          <DefaultFilledButton size="sm">
            {props.currentDeck.started ? 'Resume' : 'Start'} {props.currentDeck.name}
          </DefaultFilledButton>
        </ContextualLink>

        <ContextualLink href={paths.flashcards(props.slug)}>
          <DefaultFilledButton size="sm">
            See All Decks
          </DefaultFilledButton>
        </ContextualLink>
      </div>
    </div>
  );
};
